import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { X } from 'lucide-react';
import { Avatar } from '../../../../../../design-system/avatar/avatar/avatar';
import { Button } from '../../../../../../design-system/button/button';
import { DrawerHeader, DrawerTitle } from '../../../../../../design-system/drawer/drawer';
import { Inline } from '../../../../../../design-system/inline/inline';
import { Stack } from '../../../../../../design-system/stack/stack';

type EmployeeHeaderProps = {
  employee?: {
    id: string;
    firstName: string;
    lastName: string;
    employeeId: string;
    role?: string;
  };
  onClose: () => void;
};

export const Header = ({ employee, onClose }: EmployeeHeaderProps) => {
  if (!employee) {
    return (
      <DrawerHeader className="w-full">
        <Inline space={3} justify="between" align="start" className="w-full">
          <DrawerTitle className="text-xl leading-[28px] font-semibold tracking-[-0.02em]">New Employee</DrawerTitle>
          <Button variant="ghost" size="icon" onClick={onClose} className="-m-4" type="button">
            <X strokeWidth={1} />
          </Button>
        </Inline>
      </DrawerHeader>
    );
  }

  const fullName = `${employee.firstName} ${employee.lastName}`;

  return (
    <DrawerHeader className="relative mb-4 w-full rounded-lg bg-muted">
      <VisuallyHidden>
        <DrawerTitle>Edit Employee</DrawerTitle>
      </VisuallyHidden>
      <Inline space={3} justify="between" align="start" className="w-full">
        <Stack space={2} justify="center" align="center" className="my-10 w-full">
          <Avatar name={fullName} size="lg" />
          <h2 className="text-lg font-bold text-black">{fullName}</h2>
          <Inline space={1} className="text-sm text-gray-500">
            {employee.role && (
              <>
                <span>{employee.role}</span>
                <span>•</span>
              </>
            )}
            <span>ID: {employee.employeeId}</span>
          </Inline>
        </Stack>
      </Inline>
      <Button variant="ghost" size="icon" onClick={onClose} type="button" className="absolute top-0 right-0">
        <X strokeWidth={1} />
      </Button>
    </DrawerHeader>
  );
};
